import { routeTree } from '@routeTree.gen';
import { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
        },
    },
});

const router = createRouter({
    routeTree,
    context: { queryClient },
    // defaultPendingComponent: Loading,
    // defaultErrorComponent: ErrorComponent,
    // defaultNotFoundComponent: () => <h1>Not Found</h1>,
    scrollToTopSelectors: ['#main-content'],
    scrollRestoration: true,
    getScrollRestorationKey: location => location.href,
    // defaultComponent: () => <h1>Default</h1>,
    // routeMasks: [routeMasks],
});

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router;
    }
}

export { queryClient };
export default router;
